import React from 'react'
import { Link } from 'react-router-dom'
import './AddGame.css';

const AddGame = (props) => {
  return (<Link className="AddGame" to="/games/create">+ New Game</Link>)
}

export default AddGame
